export default __webpack_public_path__ + "static/media/pause.15763eb6.svg";